export const jsonRequiredAttribute = 'required';
export const jsonRegularExpression = 'regex';
export const jsonConditionRegularExpression = 'regex-condition';